export class PrzeniesPomieszczeniaModel {
    pomieszczeniaId: Array<string>
    lokalizacjaDocelowaId: string
    lokalizacjaAktualnaId: string
}